// extracted by mini-css-extract-plugin
export default {"FirstSection":"NewBike_FirstSection__xGVpf","Left":"NewBike_Left__h586d","DescriptionField":"NewBike_DescriptionField__0LxtQ","ImgInput":"NewBike_ImgInput__xNQPi"};